module.exports = __webpack_public_path__ + "static/fipcwhiteabcmain-cdc50523c0ecca78c801c07242d396f6.jpeg";